import { Navigation } from "components/commons/sidebar/sidebar";
import { UserContext } from "contexts";
import { Portal } from "enums";
import { useCallback, useContext, useMemo } from "react";

const useAuth = (props) => {
  const { user } = useContext(UserContext);
  const accessRole = user?.userAccesses?.find((element) => element.portal === Portal.BOS) || {};
  const { role } = accessRole;

  const stationCodes = useMemo(() => {
    const bosStations = user?.userAccesses
      ?.filter((roleAccess) => roleAccess.portal === Portal.BOS)
      .map(({ station }) => station);

    if (
      user?.userAccesses &&
      bosStations?.length > 0 &&
      bosStations?.every((station) => station && !isNaN(station?.stationCode))
    ) {
      return {
        stationCodesString: bosStations.map(({ stationCode }) => stationCode).join(","),
        stations: bosStations,
      };
    }

    return {
      stationCodesString: "",
      stations: [],
    };
  }, [user?.userAccesses]);

  const hasPermission = useCallback(
    ({ permissionsList = [] }) => {
      const checkAccess = (access) => {
        if (access.key !== props?.pageKey) return false;

        if (
          access.permission?.some((permission) => {
            if (permission.role === role && !!permission?.fullAccess) return true;

            return (
              permission.role === role &&
              Object.entries(permission).some(
                ([key, value]) => permissionsList.includes(key) && value === true
              )
            );
          })
        ) {
          return true;
        }

        if (access.items) {
          return access.items.some((item) => checkAccess(item));
        }

        return false;
      };

      return Navigation.some(checkAccess);
    },
    [props, role]
  );

  const PermissionGuard = useCallback(
    ({ permissionsList = [], children }) => {
      return hasPermission({ permissionsList }) ? children : null;
    },
    [hasPermission]
  );

  return { PermissionGuard, hasPermission, user, accessRole, stationCodes };
};

export default useAuth;
